// /react/login/LoginApp.jsx

import {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";

import {
    SmartStack,
} from "../components/smartStack/SmartStack.jsx";


import {
    LoginManualCard,
    LoginQuickCard,
} from "./LoginCard.jsx";

import {
    forgetAccount,
    getCurrentAuthUser,
    isSwitchAccountEntry,
    loadQuickAccounts,
} from "./login-auth.js";

import {
    AuthShell,
} from "../AuthShell.jsx";

import "./login.css";


export function LoginApp() {
    const [
        accounts,
        setAccounts,
    ] =
        useState(
            []
        );

    const [
        loading,
        setLoading,
    ] =
        useState(
            true
        );


    const refreshAccounts =
        useCallback(
            async () => {
                const items =
                    await loadQuickAccounts();

                setAccounts(
                    items
                );

                return items;
            },
            []
        );


    const handleForgetAccount =
        useCallback(
            async account => {
                try {
                    const result =
                        await forgetAccount(
                            account
                        );

                    if (
                        result?.redirected
                    ) {
                        return;
                    }


                    await refreshAccounts();
                } catch (
                    error
                ) {
                    console.error(
                        "[login] forget account failed:",
                        error
                    );
                }
            },
            [
                refreshAccounts,
            ]
        );


    useEffect(
        () => {
            let cancelled =
                false;

            async function initialize() {
                await window
                    .__DEVICE_READY__;


                const switchEntry =
                    isSwitchAccountEntry();


                const currentUser =
                    await getCurrentAuthUser();


                if (
                    !switchEntry &&
                    currentUser?.upn
                ) {
                    window.location.replace(
                        "/post-login"
                    );

                    return;
                }


                const items =
                    await loadQuickAccounts();


                if (
                    cancelled
                ) {
                    return;
                }


                setAccounts(
                    items
                );

                setLoading(
                    false
                );


                document
                    .documentElement
                    .dataset
                    .loginReady =
                    "1";
            }


            initialize()
                .catch(
                    error => {
                        console.error(
                            "[login] init failed:",
                            error
                        );

                        if (
                            !cancelled
                        ) {
                            setLoading(
                                false
                            );
                        }
                    }
                );


            return () => {
                cancelled =
                    true;

                unbindAuthMessages?.();
            };
        },
        []
    );


    const slides =
        useMemo(
            () => [
                {
                    key:
                        "login",

                    pageKey:
                        "login",

                    x:
                        0,

                    y:
                        0,

                    show:
                        true,

                    flippable: true,

                    defaultFlipped:
                        accounts.length ===
                        0,

                    flipAriaLabel:
                        "Přihlášení do CONTADORIA",

                    front:
                        controls => (
                            <LoginQuickCard
                                accounts={
                                    accounts
                                }

                                controls={
                                    controls
                                }

                                onForgetAccount={
                                    handleForgetAccount
                                }
                            />
                        ),

                    back:
                        controls => (
                            <LoginManualCard
                                controls={
                                    controls
                                }
                            />
                        ),
                },
            ],
            [
                accounts,
                handleForgetAccount,
            ]
        );


return (
    <AuthShell
        className="login-shell"

        contentClassName="login-left"
    >
        <div className="ld-carousel">
            <SmartStack
                slides={
                    slides
                }

                pagerPlacement="none"

                ariaLabel="Přihlášení do CONTADORIA"
            />
        </div>
    </AuthShell>
);
}